import React, { useState, useEffect } from "react";

interface WarningsWidgetProps {
  className?: string;
}

const WarningsWidget: React.FC<WarningsWidgetProps> = ({ className }) => {
  const [alertCount, setAlertCount] = useState<number>(0);

  useEffect(() => {
    setAlertCount(Math.floor(Math.random() * 500) + 100);
  }, []);

  const parodyMessages = [
    "Bon courage!",
    "On vous avait prévenu... ou pas",
    "Restez chez vous. Ou pas.",
    "Ça va bien aller... probablement",
  ];

  const randomMessage =
    parodyMessages[Math.floor(Math.random() * parodyMessages.length)];

  return (
    <div className={`lg:flex-[45] flex-1 flex flex-col ${className || ""}`}>
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-white">
          Avertissements actifs
        </h2>
        <a
          href="#"
          className="flex items-center gap-2 rounded border border-white px-3 py-1 text-sm text-white hover:bg-white hover:text-nearblack-500"
        >
          <span>Voir la liste complète</span>
          <i className="fas fa-arrow-right"></i>
        </a>
      </div>
      <a
        href="#"
        className="flex flex-1 items-center overflow-hidden rounded-lg bg-gradient-to-r from-red-alert to-orange-alert p-6"
      >
        <div className="flex items-center gap-4">
          <i className="fas fa-exclamation-triangle text-4xl text-white"></i>
          <div className="text-white">
            <div className="font-bold">Canada:</div>
            <div className="text-xl">{alertCount} Alertes en vigueur</div>
            <div className="mt-1 text-sm opacity-80">({randomMessage})</div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default WarningsWidget;
